






import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import pc from './pc/proveedores.vue';
import movil from './movil/proveedores.vue';

@Component( {
    name: "Componente",
    props: {},
    components: { pc, movil }
} )
export default class Componente extends Vue
{

    constructor()
    {
        super();
        //this.$EventBus.setTitulo( 'Cursos' );
    }

}
